
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { iCloudUpdatePromotion, iCloudUpdateQuery } from '@/interface/cloud-update-promotion';
import LogUtils from 'panda-log';
import Edit from './edit.vue';
import { formatterHour, formatterTimeByMinutes, getWeekList, toast } from '../../../utils/common';
import { deleteCloudPromotion, getCloudPromotion } from '@/api/cloud-promotion';
import moment from 'moment';
@Component({
  filters: {
    local_time_str(val: any) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  components: { Edit },
})
export default class ExchangeCode extends Mixins(PageQuery) {
  private visible = false;
  private loading = false;

  private dates: (string | Date)[] = [
    // moment()
    //   .subtract('weeks', 2)
    //   .format('YYYY-MM-DD'),
    // moment()
    //   .endOf('day')
    //   .format(),
  ];
  private model: iCloudUpdatePromotion = {
    promotion_name: '',
    game_img: '',
    is_tryout: false,
    free_time: 30,
    config: 0,
    game_id: -1,
    id: 0,
    custom: [],
    free_duration: 0,
  };
  private fromModel = {};
  typeList: any = [
    { value: -1, label: '请选择试用类型' },
    { value: 1, label: '全时段' },
    { value: 2, label: '分时段' },
  ];
  private query: iCloudUpdateQuery = {
    promotion_id: null,
    free_type: -1,
    promotion_name: '',
    start_time: null,
    end_time: null,
  };
  dateHandler(e: any) {
    if (e) {
      this.query.start_time = moment(e[0], 'YYYY-MM-DD').unix();
      this.query.end_time = moment(e[1])
        .endOf('day')
        .unix();
    } else {
      this.query.start_time = 0;
      this.query.end_time = 0;
    }
  }
  tableData = [];

  getWeekList: any = getWeekList();
  search() {
    this.page_query.page = 1;
    this.getCloudPromotion();
  }

  openModal() {
    this.visible = true;
    //this.testData;
    this.fromModel = JSON.parse(JSON.stringify(this.model));
  }
  detail(row: iCloudUpdatePromotion) {
    this.fromModel = row;
    this.visible = true;
  }
  async getCloudPromotion() {
    try {
      this.loading = true;

      const res = await getCloudPromotion({ ...this.page_query, ...this.query });
      this.tableData = res.data.list;

      this.total = res.data.total;
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  getBackupValue(row: any) {
    let value = '';

    const { custom, free_duration } = row;
    if (custom) {
      custom.forEach((item: any) => {
        let weeks = ''; //得到周期
        let times = ''; //时间；
        const { promotion_days, promotion_periods, free_duration } = item;
        /* 周期 */
        promotion_days.forEach((dayItem: string) => {
          this.getWeekList.find((weekItem: any) => {
            if (dayItem == weekItem.value) {
              weeks += weekItem.label + ',';
            }
          });
        });
        weeks = weeks.substring(0, weeks.length - 1);

        /* 自定义配置 */
        /* 时间 */
        promotion_periods.forEach((timeItem: any) => {
          times += formatterHour(timeItem.start) + '~' + formatterHour(timeItem.end) + '&nbsp;&nbsp';
        });
        /* 配置信息 */
        value += weeks + '&nbsp;&nbsp;' + times + '试用' + free_duration + '分钟<br/>';
      });
    }
    if (free_duration > 0) {
      value += custom.length > 0 ? '其他:' : '试用';
      value += free_duration + '分钟';
    } else {
      value += custom.length > 0 ? '其他时段：不试用' : '不试用';
    }
    return value == '' ? '不试用' : value;
  }
  async deleteCloudUpdate(record: any) {
    try {
      const res = await deleteCloudPromotion({ id: record.id });
      // toast((res as any).msg, 'success');
      if (res.code == 0) {
        toast('删除成功!', 'success');
        this.getCloudPromotion();
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      toast(error, 'warning');
      LogUtils.debug(error);
    }
  }
  getCodeTable() {
    this.getCloudPromotion();
    this.visible = false;
  }
  mounted() {
    this.pageFn = this.getCloudPromotion;
    this.getCloudPromotion();
  }
}
